<template>
  <div class="bzB-step" :class="{ open: isOpenEffective, done: done, locked: locked }">
    <button class="bzB-step-h" type="button" @click="!locked && $emit('toggle')">
      <span class="bzB-num" :class="{ done: done }">
        <i v-if="done" class="material-icons" style="font-size:15px;line-height:1;">check</i>
        <template v-else>{{ n }}</template>
      </span>
      <span class="bzB-step-title">
        <i class="material-icons" style="font-size:16px;line-height:1;">{{ icon }}</i>
        {{ title }}
        <span v-if="preset" class="bz-preset">pre-selected</span>
      </span>
      <span v-if="locked" class="bzB-step-val locked">
        <i class="material-icons" style="font-size:13px;line-height:1;">lock</i>{{ lockNote }}
      </span>
      <span v-else-if="done && !isOpenEffective" class="bzB-step-val">
        {{ value }}<span class="bzB-edit">Edit</span>
      </span>
      <i v-if="!locked" class="material-icons" style="font-size:18px;line-height:1;color:var(--bzc-faint);">
        {{ isOpenEffective ? 'expand_less' : 'expand_more' }}
      </i>
    </button>
    <div v-show="isOpenEffective" class="bzB-step-body">
      <slot />
    </div>
  </div>
</template>

<script>
// Step body uses v-show (not v-if) so tree expansion / search text / active tab
// survive open-close — the handoff README calls this out as a hard requirement.
export default {
  name: 'step-card',
  props: {
    n: { type: Number, required: true },
    title: { type: String, required: true },
    icon: { type: String, required: true },
    value: { type: String, default: null },
    locked: { type: Boolean, default: false },
    lockNote: { type: String, default: '' },
    preset: { type: Boolean, default: false },
    isOpen: { type: Boolean, default: false },
  },
  computed: {
    isOpenEffective() {
      return this.isOpen && !this.locked;
    },
    done() {
      return !!this.value;
    },
  },
};
</script>
